import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79e6ab83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "stat_markers" }
const _hoisted_3 = { class: "stat_markers__item_title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "stat_markers__item_icon fas fa-user-secret" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat_markers__item_subtitle" }, "Всего агентов", -1))
const _hoisted_6 = { class: "stat_markers__item_title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "stat_markers__item_icon fas fa-wallet" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat_markers__item_subtitle" }, "Баланс агентов", -1))
const _hoisted_9 = { class: "stat_markers__item_title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "stat_markers__item_icon fas fa-file-invoice-dollar" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat_markers__item_subtitle" }, "Запрошено", -1))
const _hoisted_12 = { class: "stat_markers__item_title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "stat_markers__item_icon fas fa-hand-holding-usd" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat_markers__item_subtitle" }, "Выведено денег", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["box stat_markers__item", {'loading': _ctx.ctx.isLoading}])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.ctx.stat.agents.total), 1),
          _hoisted_4
        ]),
        _hoisted_5
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box stat_markers__item", {'loading': _ctx.ctx.isLoading}])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$filters.moneyRubles(_ctx.ctx.stat.balance.total)), 1),
          _hoisted_7
        ]),
        _hoisted_8
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box stat_markers__item", {'loading': _ctx.ctx.isLoading}])
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$filters.moneyRubles(_ctx.ctx.stat.orders.requested.total)), 1),
          _hoisted_10
        ]),
        _hoisted_11
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box stat_markers__item", {'loading': _ctx.ctx.isLoading}])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.$filters.moneyRubles(_ctx.ctx.stat.orders.paid.total)), 1),
          _hoisted_13
        ]),
        _hoisted_14
      ], 2)
    ])
  ]))
}